import { FC } from 'react'
import { KTSVG } from '../../../_metronic/helpers'

const ComingSoonWrapper: FC = () => {

    return (<div className='tap-flex-center'>
        <div className="w-100">
            {/* <div className="nb-pm-header__title">
                Coming Soon
            </div> */}
            {<div className="text-dark my-team-page-description">
                Coming Soon
            </div>}
        </div>
    </div>)
}

export { ComingSoonWrapper }